// extracted by mini-css-extract-plugin
export default {"footer":"BurgerConstructor_footer__NeFlQ","section":"BurgerConstructor_section__lvpR3","button_disabled":"BurgerConstructor_button_disabled__QGhW+"};